import { Google } from '@mui/icons-material';
import {
  getAuth,
  signInWithCustomToken,
  signInWithCredential,
  OAuthProvider,
  GoogleAuthProvider,
  signInWithRedirect,
  FacebookAuthProvider
} from 'firebase/auth';

import axios from 'axios';

// ApiAccess Functions
/**
 */
export const getCustomToken = async (providerUserId) => {
  // console.log('start getCustomToken');
  let retParam;
  try {
    // signInWithCustomtokenでのAuth作成処理
    // console.log('start 3.2 firebaseにログインしていない場合');
    // 3.2 firebaseにログインしていない場合
    // 3.2.1 LIFF APIを利用して、LINEのアクセストークンを取得
    const getCustomJson = JSON.stringify({
      uuid: providerUserId
    });
    // console.log('送信前Json', getCustomJson);
    // 3.2.3 LINEのIDトークンをfirebase functionsに投げて、firebaseのカスタム認証用トークンを取得
    const NoAuthHeaders = {
      'Content-Type': 'application/json'
    };
    const getCustomTokenUrl = `${process.env.REACT_APP_API_URL}actions1/getCustomToken`;
    await axios
      .post(getCustomTokenUrl, getCustomJson, {
        headers: NoAuthHeaders
      })
      .then((result) => {
        // console.log('result', result);
        retParam = result;
      });
  } catch (e) {
    // console.log('カスタムトークン取得時にエラー発生', e);
    if (e.statusCode === 500) {
      // console.log(`eCode ${e.statusCode} ${e}`);
    }
  }
  // console.log('retParam', retParam);
  // console.log('end getCustomToken');
  return retParam;
};

export const getIdToken = async (customToken) => {
  // console.log('start getCustomToken');
  let retParam;
  try {
    // signInWithCustomtokenでのAuth作成処理
    // console.log('start 3.2 firebaseにログインしていない場合');
    // 3.2 firebaseにログインしていない場合
    // 3.2.1 LIFF APIを利用して、LINEのアクセストークンを取得
    const getCustomJson = JSON.stringify({
      customToken
    });
    // console.log('送信前Json', getCustomJson);
    // 3.2.3 LINEのIDトークンをfirebase functionsに投げて、firebaseのカスタム認証用トークンを取得
    const NoAuthHeaders = {
      'Content-Type': 'application/json'
    };
    const url = `${process.env.REACT_APP_FINDOUT_API_URL}/user1-ssoApp/exchangeCustomToken`;
    await axios
      .post(url, getCustomJson, {
        headers: NoAuthHeaders
      })
      .then((result) => {
        // console.log('result', result);
        retParam = result;
      });
  } catch (e) {
    // console.log('カスタムトークン取得時にエラー発生', e);
    if (e.statusCode === 500) {
      // console.log(`eCode ${e.statusCode} ${e}`);
    }
  }
  // console.log('retParam', retParam);
  // console.log('end getCustomToken');
  return retParam;
};

export const verifyFoIdtoken = async (headers) => {
  // console.log('start verifyFoIdtoken');
  let retParam;
  try {
    // console.log('data', data);
    // console.log('auth内, headers', headers);
    const NoDataheader = headers;
    await axios.get(`${process.env.REACT_APP_FINDOUT_API_URL}/user1-ssoApp/auth/profile`, { headers: NoDataheader }).then((result) => {
      // console.log('result', result);
      retParam = result;
    });
    // await axios
    //   .post(`${process.env.FINDOUT_API_URL}/user1-ssoApp/auth/profile`, data, {
    //     headers
    //   })
    //   .then((result) => {
    //     console.log('result', result);
    //     retParam = result;
    //   });
  } catch (e) {
    // console.log('error', e);
    if (e.statusCode === 401) {
      // findout authユーザの情報取得に失敗
      // console.log(`eCode ${e.statusCode} ${e}`);
    }
    if (e.statusCode === 500) {
      // findout authユーザの情報取得に失敗
      // console.log(`eCode ${e.statusCode} ${e}`);
    }
  }
  // console.log('retParam', retParam);
  // console.log('end verifyFoIdtoken');
  return retParam;
};
export const refreshIdtoken = async (headers, data) => {
  // console.log('start refreshIdtoken');
  let retParam;
  try {
    const url = `${process.env.REACT_APP_FINDOUT_API_URL}/user1-ssoApp/refreshIdtoken`;
    await axios
      .post(url, data, {
        headers
      })
      .then((result) => {
        // console.log('result', result);
        retParam = result;
      });
  } catch (e) {
    // console.log('Idtoken取得時にエラー発生', e);

    if (e.statusCode === 401) {
      // console.log(`eCode ${e.statusCode} ${e}`);
      retParam = e;
      return retParam;
    }
    if (e.statusCode === 500) {
      // console.log(`eCode ${e.statusCode} ${e}`);
      retParam = e;
      return retParam;
    }
    // console.log(`eCode ${e.statusCode} ${e}`);
    retParam = e;
    return retParam;
  }
  // console.log('retParam', retParam);
  // console.log('end refreshIdtoken');
  return retParam;
};

export const revokeIdtoken = async (headers, data) => {
  // console.log('start revokeIdtoken');
  let retParam;
  try {
    const url = `${process.env.REACT_APP_FINDOUT_API_URL}/user1-ssoApp/logout`;
    await axios
      .post(url, data, {
        headers
      })
      .then((result) => {
        // console.log('result', result);
        retParam = result;
      });
  } catch (e) {
    // console.log('ログアウト時にエラー発生', e);

    if (e.statusCode === 401) {
      // console.log(`eCode ${e.statusCode} ${e}`);
      retParam = e;
      return retParam;
    }
    if (e.statusCode === 500) {
      // console.log(`eCode ${e.statusCode} ${e}`);
      retParam = e;
      return retParam;
    }
    // console.log(`eCode ${e.statusCode} ${e}`);
    retParam = e;
    return retParam;
  }
  // console.log('retParam', retParam);
  // console.log('end revokeIdtoken');
  return retParam;
};
